import React from "react";
import "./styles.css";

const Logo = ({ logo = null, className }) => {
  const logoPath = logo
    ? logo
    : `${window.location.origin}/assets/logo/sayagie-mark.png`;

  return (
    <div className={`${className ? `${className} "logo-img"` : "logo-img"}`}>
      <img src={logoPath} alt="brand-logo" />
    </div>
  );
};

export default Logo;
